import { useSuspenseQuery } from '~/services'

export const useActiveSubscription = (workspaceId: string) => {
  const { data: subscriptions } = useSuspenseQuery('workspaces_/$workspaceId_/billing/subscriptions', { workspaceId })

  const activeSubscriptions = subscriptions.filter((sub) => sub.status === 'active')
  return {
    monthly: activeSubscriptions.find((subscription) =>
      subscription.items.data.some((item) => item.price.recurring?.interval === 'month')
    ),
    yearly: activeSubscriptions.find((subscription) =>
      subscription.items.data.some((item) => item.price.recurring?.interval === 'year')
    ),
  }
}
